import React, { useMemo } from "react";
import configData from '../json/RightPanelStyles.json';  // Import des styles JSON
import { mockCost } from '../mocks/mockCosts';

const RightPanel_102_ZoneA2 = ({ costData = mockCost }) => {
  // Récupération des styles depuis le fichier JSON
  const { panel, panelHeader, panelTitle, block, blockTitle, rows, kvRow, kvLabel, kvValue } = configData;

  // Calculs ou transformations si nécessaires (ici c'est un mock, donc les données sont déjà prêtes)
  const completionRateColor = costData.completionRate >= 75 ? "#166A58" : "#8A4A13";
  const varianceColor = costData.variance > 0 ? "#9A4315" : "#166A58";

  return (
    <div style={panel}>
      {/* Header du panneau */}
      <div style={panelHeader}>
        <div style={panelTitle}>Cost Overview</div>
      </div>

      {/* Bloc des informations générales */}
      <div style={block}>
        <div style={blockTitle}>General Information</div>
        <div style={rows}>
          <div style={kvRow}>
            <div style={kvLabel}>Total Cost</div>
            <div style={kvValue}>{costData.totalCost}</div>
          </div>
          <div style={kvRow}>
            <div style={kvLabel}>Planned Cost</div>
            <div style={kvValue}>{costData.plannedCost}</div>
          </div>
          <div style={kvRow}>
            <div style={kvLabel}>Actual Cost</div>
            <div style={kvValue}>{costData.actualCost}</div>
          </div>
          <div style={kvRow}>
            <div style={kvLabel}>Remaining Cost</div>
            <div style={kvValue}>{costData.remainingCost}</div>
          </div>
        </div>
      </div>

      {/* Bloc du taux de complétion */}
      <div style={block}>
        <div style={blockTitle}>Completion Rate</div>
        <div style={kvRow}>
          <div style={kvLabel}>Completion</div>
          <div style={{ ...kvValue, color: completionRateColor }}>
            {costData.completionRate}%
          </div>
        </div>
      </div>

      {/* Bloc des variations */}
      <div style={block}>
        <div style={blockTitle}>Variance</div>
        <div style={kvRow}>
          <div style={kvLabel}>Variance Amount</div>
          <div style={{ ...kvValue, color: varianceColor }}>
            {costData.variance}
          </div>
        </div>
      </div>

      {/* Bloc pour les coûts prêts à être approuvés */}
      <div style={block}>
        <div style={blockTitle}>Ready for Approval</div>
        <div style={kvRow}>
          <div style={kvLabel}>Cost Ready for Approval</div>
          <div style={kvValue}>{costData.costReadyForApproval}</div>
        </div>
      </div>
    </div>
  );
};

export default RightPanel_102_ZoneA2;